<template>
  <el-dialog
    :modal="isModal"
    class="fileUpDia"
    title="文件正在上传"
    :visible="!upDone"
    top="15%"
    @close="close"
    width="600px">
    <div class="body">
      <template v-if="validFilesStatus.length > 0">
        <div
          class="list"
          v-for="(item,i) in validFilesStatus"
          :key="i">
          <el-progress
            :text-inside="true"
            :stroke-width="16"
            :percentage="item.percentage"
            :status="item.percentage===100?'success':'warning'">
          </el-progress>
          <span>{{item.fileName}}</span>
        </div>
      </template>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "UpLoadFileStatus",
    props:{
      filesStatus:{
        type:Array,
        default(){
          return [
            {
              fileName:"一怒气山河.doc",
              percentage:38,
              status:''
            }
          ]
        }
      },
      upDone:{
        type:Boolean,
        default() {
          return false;
        }
      },
      isModal:{
        type:Boolean,
        default(){
          return true;
        }
      }
    },
    computed: {
      validFilesStatus() {
        // 过滤掉 undefined 或 null 的项
        return this.filesStatus.filter(item => item && item.fileName);
      }
    },
    methods:{
      close(){
        //console.log("关闭");
        // 都为100%则可以关闭,否则无法关闭
        let okFile=0;
        let totalFile=this.validFilesStatus.length*100;
        this.validFilesStatus.forEach(item=>{
          if(item && item.percentage===100)
            okFile+=100;
        });
        if(okFile===totalFile){
          this.$emit("upFileClose",true);
        }else {
          let that = this;
          this.$confirm("文件还未上传完成,确认取消上传吗？", '提示',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.$emit("upFileCancel",true);
          }).catch(() => {

          });
        }
      }
    },

  }
</script>

<style scoped lang="less">
  .fileUpDia{
    /deep/ .el-dialog__body{
      overflow: auto;
      padding-bottom: 20px;
      max-height: none;
      max-width: none;
    }
    .body{
      .list{
        padding:0 20px;
        display: flex;
        .el-progress {
          width: 70%;
        }
        span{
          width: 20%;
          flex: 1 1 auto;
          white-space: nowrap; /*隐藏超出文本*/
          overflow: hidden; /*//显示出...*/
          text-overflow: ellipsis;
        }
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/detail/UpLoadFileStatus.vue